import React        from 'react'

const STATS_TABS_FILTER   =  [
  { tab:'scoring',   data:[ 'tries', 'tryassists', 'conversiongoals', 'penaltygoals', 'dropgoalsconverted', 'points' ] },
  { tab:'attacking', data:[ 'kicks','passes','runs','metres','cleanbreaks','defendersbeaten','offload','lineoutwonsteal' ] },
  { tab:'defending', data:[ 'turnoversconceded','tackles','missedtackles','lineoutswon' ] },
  { tab:'discipline',  data:[ 'penaltiesconceded','yellowcards','redcards' ] }
]

const PlayerTable = ({
  team      = {},
  stats     = [],
  glossary  = {}
}) => {
  
  let rows = []
  let headings = [ <th key="logo"><img src={team.logo} className="imageLoaded"/> {team.name}</th> ]
  
  const players = team.team.concat(team.reserves)
  const len = players.length
  const lenStats = stats.length

  for ( let a = 0; a < len; a++ ) {
    
    const player = players[a]
    const nameParts = (player.name || '').split(' ')
    const firstChar = (player.name || '')[0]
    const lastName = nameParts[nameParts.length-1] || ''
    const playerName = firstChar + ' ' + lastName
    
    let cell = [
      <td key={player.id}>
        {
          player.url && 
          <a target="_blank" href={ player.url }>{ playerName }</a>    
          ||
          <span>{playerName}</span>
        }      
        <span style={ { fontFamily:'inherit', paddingLeft:'3px' } } className="tooltip icon-font icon-soccer-goal-solid" data-tooltip={player.position}>
          {player.position}
        </span>
      </td>
    ] 
    
    for ( let b = 0; b < lenStats; b++ ) {
      cell.push(
        <td key={b} >{player[stats[b]].value}</td>
      )
      
      if ( a===0 ) {
        const headGloss = glossary[stats[b]] || {}
        headings.push(
          <th key={b}>
            <span style={ { fontFamily:'inherit',fontWeight:'inherit' } } className="tooltip icon-font icon-soccer-goal-solid" data-tooltip={ headGloss.desc || headGloss.abbr || '-' }>{ headGloss.abbr || '-' }</span>
          </th>
        )
      }
    }
    
    rows.push(
      <tr key={'r.' + a}>
        {cell}
      </tr>
    )
  }
    
  return (
    <table className="mod-data">
      <thead>
        <tr className="header">
          {headings}
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>
  )
}


const Tables = ({
  home      = {},
  away      = {},
  stats     = [],
  team      = [],
  glossary  = {}
}) => {

  return (
    <div>
      <div className={'table-wrap' + (team === 'home' ? ' active' : '')}>
        <PlayerTable team={home} stats={stats} glossary={glossary} />
      </div>
      <div className={'table-wrap' + (team === 'away' ? ' active' : '')}>
        <PlayerTable team={away} stats={stats} glossary={glossary} />
      </div>
    </div>
  )
    
}

class PlayerStats extends React.Component {

  constructor( props ) {
    super(props)
    this.state = {
      selected :    'scoring',
      selectedTeam :  'home'
    }
  }

  clickHandler( selected ) {
    this.setState({
      selected : selected
    })
  }

  switchTeam( team ) {
    this.setState({
      selectedTeam : team
    })
  }

  render() {

    const home          = this.props.home || {}
    const away          = this.props.away || {}
    const text          = this.props.text || {}
    const sport         = this.props.sport || 'rugby'
    const iLen          = STATS_TABS_FILTER.length || 0
    const selected      = this.state.selected
    let stats           = []
    let tabsList        = []    
    
    for ( let i = 0, l = iLen; i < l; i++ ) {
      const tabInfo = STATS_TABS_FILTER[i]
      let props = {}
      if ( selected === tabInfo.tab ) {
        props.className = 'active'
        stats = tabInfo.data
        if ( selected == 'defending' && sport == 'rugby-league' ) {
          stats = [ 'turnoversconceded','tackles','missedtackles' ]
        } else if ( selected == 'attacking' && sport == 'rugby-league' ) {
          stats = [ 'kicks','passes','runs','metres','cleanbreaks','defendersbeaten','offload' ]
        }
      }
      tabsList.push(<li onClick={this.clickHandler.bind(this, tabInfo.tab)} key={tabInfo.tab} {...props}><span>{ text[tabInfo.tab] || '-' }</span></li>)
    }
    
    return (
      <div className="sub-module tabbedTable" style={ { overflowX:'auto' } }>
        <header className="hidden-sm hidden-md hidden-lg">
          <div className="filter form-group button-group">
            <button onClick={this.switchTeam.bind(this,'home')} className={'button-filter-alt lg fixed' + (this.state.selectedTeam === 'home' ? ' active' : '')}><span className="team-name">{home.name}</span></button>
            <button onClick={this.switchTeam.bind(this,'away')} className={'button-filter-alt lg fixed' + (this.state.selectedTeam === 'away' ? ' active' : '')}><span className="team-name">{away.name}</span></button>
          </div>
        </header>

        <div className="tab-container alt">
          <ul className="tabs alt" data-behavior="tabs_transform">
            {tabsList}
          </ul>
        </div>
          
        <div className="tab-content">
          <div className={'tab-pane' + this.state.selected == 'scoring' ? ' active' : ''}>
            <Tables team={this.state.selectedTeam} home={home} away={away} stats={stats} glossary={this.props.glossary} />
          </div> 
        </div>
      </div>
    )
  }
}

export default PlayerStats



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/PlayerStats.jsx
 **/